var map = {
	"./Commoditie.js": "ce74",
	"./Course.js": "aa19",
	"./Creation.js": "a273",
	"./Login.js": "4bed",
	"./Studio.js": "15fe",
	"./Teacher.js": "cd10",
	"./User.js": "1913",
	"./Video.js": "c843",
	"./Vip.js": "3201"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "d56b";